var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showDialog
        ? _c("ModalFullScreen", {
            on: { close: _vm.closeModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("ModalHeader", { attrs: { title: _vm.modalTitle } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "form",
                  fn: function () {
                    return [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ handleSubmit }) {
                                return [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "title",
                                      rules: "required_field",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  title: "Area Of Study*",
                                                  name: "education title",
                                                  placeholder: "Enter title",
                                                  errors: errors,
                                                },
                                                model: {
                                                  value: _vm.title,
                                                  callback: function ($$v) {
                                                    _vm.title = $$v
                                                  },
                                                  expression: "title",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "institution",
                                      rules: "required_field",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  title: "Institution*",
                                                  name: "education institution",
                                                  placeholder:
                                                    "Enter institution",
                                                  errors: errors,
                                                },
                                                model: {
                                                  value: _vm.institution,
                                                  callback: function ($$v) {
                                                    _vm.institution = $$v
                                                  },
                                                  expression: "institution",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-1 grid grid-cols-2 gap-8",
                                    },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          vid: "start_date",
                                          name: "start date",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        title: "Start Date",
                                                        name: "start date",
                                                        errors: errors,
                                                      },
                                                    },
                                                    [
                                                      _c("FormDatepicker", {
                                                        attrs: {
                                                          heightClass:
                                                            "datePickerHeight",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: "noBeforeDate:@start_date",
                                          name: "end date",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        title: "End Date",
                                                        name: "end date",
                                                        errors: errors,
                                                      },
                                                    },
                                                    [
                                                      _c("FormDatepicker", {
                                                        attrs: {
                                                          name: "end date",
                                                          errors: errors,
                                                          heightClass:
                                                            "datePickerHeight",
                                                        },
                                                        model: {
                                                          value: _vm.endDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.endDate = $$v
                                                          },
                                                          expression: "endDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormGroup",
                                    { attrs: { title: "Note" } },
                                    [
                                      _c("FormTextarea", {
                                        attrs: {
                                          customBorderClass: "borderTen",
                                          placeholder: "Summary",
                                          name: "education summary",
                                        },
                                        model: {
                                          value: _vm.summary,
                                          callback: function ($$v) {
                                            _vm.summary = $$v
                                          },
                                          expression: "summary",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "pt-5 flex justify-end" },
                                    [
                                      _c("UIButton", {
                                        staticClass: "mr-3",
                                        attrs: {
                                          variant: "outline",
                                          buttonText: "Cancel",
                                        },
                                        on: { click: _vm.closeModal },
                                      }),
                                      _vm.isEditing
                                        ? _c("UIButton", {
                                            attrs: {
                                              variant: "black",
                                              buttonText: "Update",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return handleSubmit(_vm.submit)
                                              },
                                            },
                                          })
                                        : _c("UIButton", {
                                            attrs: {
                                              variant: "black",
                                              buttonText: "Add",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return handleSubmit(_vm.submit)
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2311894169
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2412382600
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }